"use client"

/* global gdAlertify */
import { useState, useEffect } from "react"
import axiosInstance from "../config/axiosConfig" // Asegúrate de tener tu configuración de axios
import BuscarPaciente from "./components/BuscarPaciente" // Componente para buscar pacientes
import BuscarAuxiliar from "./components/BuscarAuxiliar" // Componente para buscar auxiliares
import { calculateAge } from "../utils/utils"
import Select from "react-select"
import { formatDate } from "../utils/utils";
import { useNavigate } from "react-router-dom";

function AcuerdoMutuo() {
    const navigate = useNavigate();

    const [datosDias, setdatosDias] = useState([])
    const [datosAuxiliarAcuerdos, setdatosAuxiliarAcuerdos] = useState([])

    const [slotIndexMap, setSlotIndexMap] = useState({});


    const [slots, setSlots] = useState([])
    const [usedSlots, setUsedSlots] = useState([])
    const handleSlotSelect = (slot, index) => {
        if (slot.status !== "libre") return;

        setAcuerdoMutuo(prev => {
            const actual = [...(prev.patternIndexes || [])];
            const idx = actual.indexOf(index);

            if (idx !== -1) {
                // Ya está seleccionado, lo quitamos
                actual.splice(idx, 1);
            } else {
                // Lo agregamos
                actual.push(index);
            }

            return {
                ...prev,
                patternIndexes: actual
            };
        });
    };

    const diasMap = {
        Mon: 'Lunes',
        Tue: 'Martes',
        Wed: 'Miércoles',
        Thu: 'Jueves',
        Fri: 'Viernes',
        Sat: 'Sábado',
        Sun: 'Domingo',
    };

    const getSlotLabelHumano = (slotIndex, slots, fechaInicioReal) => {
        const diasMap = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];

        // Fecha de inicio real del servicio
        const [anio, mes, dia] = fechaInicioReal.split("-").map(Number);
        const fechaInicio = new Date(anio, mes - 1, dia);

        // Calcular cuántos días han pasado desde el inicio hasta este slot
        let diasDesdeInicio = 0;
        for (let i = 0; i < slotIndex; i++) {
            diasDesdeInicio += parseInt(slots[i].days || 0);
        }

        const duracion = parseInt(slots[slotIndex].days || 0);
        const diasAsignados = [];

        for (let j = 0; j < duracion; j++) {
            const fecha = new Date(fechaInicio);
            fecha.setDate(fecha.getDate() + diasDesdeInicio + j);
            const nombreDia = diasMap[fecha.getDay()];
            diasAsignados.push(nombreDia);
        }

        // Armar texto amigable
        let textoDias;
        if (diasAsignados.length === 1) {
            textoDias = diasAsignados[0];
        } else if (diasAsignados.length === 2) {
            textoDias = `${diasAsignados[0]} y ${diasAsignados[1]}`;
        } else {
            textoDias = `${diasAsignados[0]} a ${diasAsignados[diasAsignados.length - 1]}`;
        }

        let periodo = "";
        switch (slots[slotIndex].period) {
            case 'day': periodo = "Día"; break;
            case 'night': periodo = "Noche"; break;
            case 'full': periodo = "Completo"; break;
            case 'mixto': periodo = "Mixto"; break;
            default: periodo = "¿?";
        }

        return `${textoDias} - ${periodo}`;
    };


    // Definir los días de la semana como constante
    const diasSemanaBase = [
        { value: 1, label: "Lunes" },
        { value: 2, label: "Martes" },
        { value: 3, label: "Miércoles" },
        { value: 4, label: "Jueves" },
        { value: 5, label: "Viernes" },
        { value: 6, label: "Sábado" },
        { value: 7, label: "Domingo" },
    ]

    const diasTextoToNumero = {
        Mon: 1,
        Tue: 2,
        Wed: 3,
        Thu: 4,
        Fri: 5,
        Sat: 6,
        Sun: 7
    };

    // const diasServicio = turnosPatron?.daysService?.split(",").map(d => diasTextoToNumero[d]) || [];

    // const diaSemanaInicio = obtenerDiaSemana(acuerdoMutuo.fechaInicio); // 1=Lunes ... 7=Domingo
    // const diasOrdenados = getDiasOrdenados(diaSemanaInicio);


    // Estado para los días ordenados según la fecha seleccionada
    const [daysOfWeek, setDaysOfWeek] = useState(diasSemanaBase)

    // Función para obtener los días ordenados a partir del día inicial
    const getDiasOrdenados = (diaInicial) => {
        if (!diaInicial) return diasSemanaBase

        const diasOrdenados = []
        // Agregar los días desde el día inicial hasta el final de la semana
        for (let i = diaInicial; i <= 7; i++) {
            const dia = diasSemanaBase.find((d) => d.value === i)
            if (dia) diasOrdenados.push(dia)
        }
        // Agregar los días desde el inicio de la semana hasta el día inicial
        for (let i = 1; i < diaInicial; i++) {
            const dia = diasSemanaBase.find((d) => d.value === i)
            if (dia) diasOrdenados.push(dia)
        }
        return diasOrdenados
    }

    const [acuerdoMutuo, setAcuerdoMutuo] = useState({
        idPaciente: null, // Solo ID del paciente
        idAuxiliar: null, // Solo ID del auxiliar
        celular: "",
        fechaInicio: "",
        horaInicio: "",
        horaFin: "",
        tipoTurno: "",
        valorTurno: "",
        valorColacion: "",
        valorMovilizacion: "",
        valorOtro: "",
        observacion: "",
        patternIndex: null,
        patternIndexes: [],
        tipo_colacion: 3,
    })

    const [turnos, setTurnos] = useState([]) // Estado para turnos

    // Cargar los turnos desde el backend
    useEffect(() => {
        const obtenerTurnos = async () => {
            try {
                const response = await axiosInstance.get("/params/turnos") // Cambiar al endpoint correcto
                if (response.data && !response.data.error) {
                    setTurnos(
                        response.data.turnos.map((turno) => ({
                            value: turno.id,
                            label: turno.nombre,
                            dias: turno.dias, // Agregamos los días del turno
                        })),
                    )
                } else {
                    if (typeof gdAlertify !== "undefined") {
                        gdAlertify.notiError("No se pudieron cargar los turnos.")
                    } else {
                        console.error("gdAlertify is not defined")
                    }
                }
            } catch (error) {
                console.error(error)
                if (typeof gdAlertify !== "undefined") {
                    gdAlertify.notiError("Ocurrió un error al cargar los turnos.")
                } else {
                    console.error("gdAlertify is not defined")
                }
            }
        }

        obtenerTurnos()
    }, [])

    const handleTurnoChange = (selectedOption) => {
        setAcuerdoMutuo({ ...acuerdoMutuo, tipoTurno: selectedOption ? selectedOption.value : "" })
        if (selectedOption && acuerdoMutuo.fechaInicio) {
            let dias = selectedOption.dias;
            if (selectedOption.value == 7) {
                dias = pacienteInfo.diasTurno ?? 1;
            }
            actualizarDiasMarcados(acuerdoMutuo.fechaInicio, dias)
        }
    }

    const handleFechaInicioChange = (e) => {
        const { value } = e.target;

        setAcuerdoMutuo(prev => ({ ...prev, fechaInicio: value }));

        // Reordenar los días si ya hay datos cargados
        if (datosDias.length > 0) {
            const diaSemanaInicio = obtenerDiaSemana(value);
            setDaysOfWeek(getDiasOrdenados(diaSemanaInicio));
        }
    };

    // Función para obtener el día de la semana correcto (1-7) a partir de una fecha
    const obtenerDiaSemana = (fechaStr) => {
        // Asegurarse de que la fecha se interprete correctamente
        const partesFecha = fechaStr.split("-")
        const fecha = new Date(
            Number.parseInt(partesFecha[0]), // año
            Number.parseInt(partesFecha[1]) - 1, // mes (0-11)
            Number.parseInt(partesFecha[2]), // día
        )

        // getDay() devuelve 0 para domingo, 1 para lunes, etc.
        let diaSemana = fecha.getDay()

        // Convertir al formato de nuestro array (1=Lunes, 7=Domingo)
        diaSemana = diaSemana === 0 ? 7 : diaSemana

        console.log("Fecha:", fechaStr)
        console.log("Día de la semana (0-6):", fecha.getDay())
        console.log("Día de la semana (1-7):", diaSemana)

        return diaSemana
    }

    // Función para actualizar los días marcados según la fecha de inicio y duración
    const actualizarDiasMarcados = (fechaInicio, duracionDias) => {
        if (!fechaInicio || !duracionDias) return

        // Obtener el día de la semana correcto
        const diaSemana = obtenerDiaSemana(fechaInicio)

        // Actualizar el orden de los días para que comience con el día seleccionado
        setDaysOfWeek(getDiasOrdenados(diaSemana))

        const diasSeleccionados = []

        // Agregar los días consecutivos según la duración del turno
        for (let i = 0; i < duracionDias; i++) {
            // Calcular el día actual y los siguientes, con wrap-around (si pasa de 7, vuelve a 1)
            const diaActual = ((diaSemana + i - 1) % 7) + 1
            diasSeleccionados.push(diaActual)
        }

        console.log("Duración:", duracionDias)
        console.log("Días seleccionados:", diasSeleccionados)

        setdatosDias(diasSeleccionados)
    }

    const [pacienteInfo, setPacienteInfo] = useState(null) // Detalles del paciente
    const [auxiliarInfo, setAuxiliarInfo] = useState(null) // Detalles del auxiliar

    useEffect(() => {
        if (!pacienteInfo?.inicioRealServicio || !acuerdoMutuo.patternIndexes || slots.length === 0) return;

        const [anio, mes, dia] = pacienteInfo.inicioRealServicio.split("-").map(Number);
        const fechaInicio = new Date(anio, mes - 1, dia);

        const nuevosDias = [];

        acuerdoMutuo.patternIndexes.forEach(index => {
            let diasDesdeInicio = 0;

            for (let i = 0; i < index; i++) {
                diasDesdeInicio += parseInt(slots[i].days || 0);
            }

            const duracion = parseInt(slots[index].days || 0);
            for (let j = 0; j < duracion; j++) {
                const fecha = new Date(fechaInicio);
                fecha.setDate(fecha.getDate() + diasDesdeInicio + j);

                // Solo marcar si ese día está en days_service
                const diaSemana = fecha.getDay(); // 0 = Domingo ... 6 = Sábado
                const diaNumerico = diaSemana === 0 ? 7 : diaSemana;

                const diasValidos = pacienteInfo.patronTurno.days_service
                    .split(',')
                    .map(d => diasTextoToNumero[d.trim()]);

                if (diasValidos.includes(diaNumerico) && !nuevosDias.includes(diaNumerico)) {
                    nuevosDias.push(diaNumerico);
                }
            }
        });

        setdatosDias(nuevosDias.sort((a, b) => a - b));
    }, [acuerdoMutuo.patternIndexes, slots, pacienteInfo]);



    // Manejar la selección de paciente
    const handleSeleccionPaciente = (paciente) => {
        console.log(paciente)
        let valorTurno,
            valorColacion,
            valorMovilizacion,
            valorOtro = 0
        if (paciente.valoresTurnos.length > 0) {
            valorTurno = paciente.valoresTurnos[0].valorTurnoAuxiliar
            valorColacion = paciente.valoresTurnos[0].valorColacionAuxiliar
            valorMovilizacion = paciente.valoresTurnos[0].valorLocomocionAuxiliar
            valorOtro = paciente.valoresTurnos[0].valorOtroAuxiliar
        }
        setAcuerdoMutuo({
            ...acuerdoMutuo,
            idPaciente: paciente.id, // Solo guardamos el ID en el estado principal
            tipoTurno: Number.parseInt(paciente.tipoTurno),
            horaInicio: paciente.horaInicio,
            horaFin: paciente.horaFin,
            valorTurno: valorTurno,
            valorColacion: valorColacion,
            valorMovilizacion: valorMovilizacion,
            valorOtro: valorOtro
        })

        setPacienteInfo(paciente) // Guardamos los detalles completos en un estado independiente

        const turnosPatron = JSON.parse(paciente.patronTurno.rotation_pattern) || [];
        let nuevosSlots = turnosPatron;

        if (paciente.inicioRealServicio && paciente.patronTurno?.days_service) {
            const fechaInicio = paciente.inicioRealServicio;
            const [anio, mes, dia] = fechaInicio.split("-").map(Number);
            const fecha = new Date(anio, mes - 1, dia);

            // No hacemos ningún reordenamiento de slots ni de days_service
        }

        setPacienteInfo({ ...paciente });
        setSlots(nuevosSlots);
        setSlotIndexMap({});


        // 1. Procesar daysService y guardar los días referenciales
        const diasTextoToNumero = {
            Mon: 1,
            Tue: 2,
            Wed: 3,
            Thu: 4,
            Fri: 5,
            Sat: 6,
            Sun: 7
        };

        const diasServicio = paciente.patronTurno.days_service?.split(",").map(d => diasTextoToNumero[d]) || [];
        setdatosDias(diasServicio);

        // 2. Si ya hay fechaInicio, reordenar visualmente la semana
        if (paciente.inicioRealServicio) {
            setAcuerdoMutuo(prev => ({ ...prev, fechaInicio: paciente.inicioRealServicio }));
            // 2. Si ya hay fechaInicio (en este caso la asignamos nosotros), reordenar visualmente la semana
            const diaSemanaInicio = obtenerDiaSemana(paciente.inicioRealServicio);
            setDaysOfWeek(getDiasOrdenados(diaSemanaInicio));
        } else if (acuerdoMutuo.fechaInicio) {
            // 2. Si ya había fechaInicio manual, reordenar
            const diaSemanaInicio = obtenerDiaSemana(acuerdoMutuo.fechaInicio);
            setDaysOfWeek(getDiasOrdenados(diaSemanaInicio));
        }

        setdatosAuxiliarAcuerdos(paciente.auxiliares)
    }

    // Manejar la selección de auxiliar
    const handleSeleccionAuxiliar = (auxiliar) => {
        setAcuerdoMutuo({
            ...acuerdoMutuo,
            idAuxiliar: auxiliar.id, // Solo guardamos el ID en el estado principal
            celular: auxiliar.celular,
        })
        setAuxiliarInfo(auxiliar) // Guardamos los detalles completos en un estado independiente
    }

    // Manejar cambios en los inputs
    const handleChange = (e) => {
        const { name, value } = e.target
        setAcuerdoMutuo({ ...acuerdoMutuo, [name]: value })
    }

    const recargar = () => {
        // fallback robusto
        setTimeout(() => {
            console.log('recargando');
            // 1) hard reload del documento
            window.location.href = window.location.href; // equivalente práctico a reload()
            // o: window.location.reload();
        }, 120); // pequeño delay para dejar cerrar el modal y terminar otros eventos
    };

    const resetFormulario = () => {
        setAcuerdoMutuo({
            idPaciente: null,
            idAuxiliar: null,
            celular: "",
            fechaInicio: "",
            horaInicio: "",
            horaFin: "",
            tipoTurno: "",
            valorTurno: "",
            valorColacion: "",
            valorMovilizacion: "",
            valorOtro: "",
            observacion: "",
            patternIndex: null,
            patternIndexes: [],
        });

        setPacienteInfo(null);
        setAuxiliarInfo(null);
        setSlots([]);
        setdatosDias([]);
        setdatosAuxiliarAcuerdos([]);
        setDaysOfWeek(diasSemanaBase);
    }


    const handleSubmit = async (e) => {
        e.preventDefault()
        // Validar que el celular esté completo
        if (acuerdoMutuo.celular === "") {
            if (typeof gdAlertify !== "undefined") {
                gdAlertify.notiError("Falta numero celular.")
            } else {
                console.error("gdAlertify is not defined")
            }
            return false
        }

        if (acuerdoMutuo.fechaInicio === "") {
            if (typeof gdAlertify !== "undefined") {
                gdAlertify.notiError("Falta fecha inicio servicio.")
            } else {
                console.error("gdAlertify is not defined")
            }
            return false
        }

        if (typeof gdAlertify !== "undefined") {
            gdAlertify.confirm({
                title: "Confirmar acuerdo",
                message: '¿Está seguro de generar el acuerdo mutuo?',
                onConfirm: async () => {
                    gdAlertify.showLoader()
                    try {

                        const patternIndexesOriginales = acuerdoMutuo.patternIndexes.map(i => slotIndexMap[i]);
                        const payload = {
                            ...acuerdoMutuo,
                            inicioRealServicio: pacienteInfo?.inicioRealServicio
                        };

                        const response = await axiosInstance.post("/acuerdo-mutuo/registrar", payload)
                        gdAlertify.hideLoader()
                        if (!response.data.error) {
                            if (typeof gdAlertify !== "undefined") {
                                gdAlertify.notiSuccess(response.data.message)
                            } else {
                                console.error("gdAlertify is not defined")
                            }
                            setdatosAuxiliarAcuerdos(response.data.data)
                            resetFormulario();
                            gdAlertify.hideLoader()
                            // Confirmar si desea enviar el resumen por WhatsApp
                            gdAlertify.confirm({
                                title: "Confirmar envío",
                                message: "¿Desea enviar el resumen del acuerdo mutuo por WhatsApp?",
                                onConfirm: () => {
                                    // Crear el mensaje para enviar por WhatsApp
                                    const mensaje = crearMensajeWhatsapp(acuerdoMutuo)
                                    const phoneNumber = "56" + acuerdoMutuo.celular // Cambiar con el número de destino
                                    const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(mensaje)}`
                                    window.open(whatsappUrl, "_blank")
                                    console.log('recargar')
                                    if (typeof gdAlertify !== "undefined") {
                                        // gdAlertify.alertSuccess("Acuerdo mutuo creado con éxito")
                                    } else {
                                        console.error("gdAlertify is not defined")
                                    }
                                    window.location.reload();
                                },
                                onCancel: () => {
                                    console.log('recargar')
                                    resetFormulario();
                                    if (typeof gdAlertify !== "undefined") {
                                        // gdAlertify.alertSuccess("Acuerdo mutuo creado con éxito")
                                    } else {
                                        console.error("gdAlertify is not defined")
                                    }
                                    window.location.reload();
                                },
                            })
                        } else {
                            if (typeof gdAlertify !== "undefined") {
                                gdAlertify.notiError(response.data.message)
                            } else {
                                console.error("gdAlertify is not defined")
                            }

                        }
                    } catch (error) {
                        gdAlertify.hideLoader()
                        if (typeof gdAlertify !== "undefined") {
                            gdAlertify.notiError("Ocurrió un error al conectar con el servidor.")
                        } else {
                            console.error("gdAlertify is not defined")
                        }
                    }
                },
                onCancel: () => {
                    if (typeof gdAlertify !== "undefined") {
                        gdAlertify.notify("Envío cancelado", "error")
                    } else {
                        console.error("gdAlertify is not defined")
                    }
                },
            })
        } else {
            console.error("gdAlertify is not defined")
        }
    }

    // Función para crear el mensaje de WhatsApp con un formato atractivo
    const crearMensajeWhatsapp = (acuerdoMutuo) => {
        const paciente = pacienteInfo
            ? `${pacienteInfo.nombres} ${pacienteInfo.apellidoPaterno}`
            : "Paciente no seleccionado"
        const auxiliar = auxiliarInfo
            ? `${auxiliarInfo.nombre} ${auxiliarInfo.apellidoPaterno}`
            : "Auxiliar no seleccionado"

        return `
📑 *Resumen Acuerdo Mutuo* 📑
    
🏥 *Paciente:* ${paciente}
🏥 *Diagnostico:* ${pacienteInfo.diagnostico}
🏥 *Edad:* ${calculateAge(pacienteInfo.fechaNacimiento)}
🏥 *Direccion:* ${pacienteInfo.direccion}
🏥 *Comuna:* ${pacienteInfo.desc_comuna}
👩‍⚕️ *Auxiliar:* ${auxiliar}

📅 *Fecha de inicio:* ${acuerdoMutuo.fechaInicio}
⌚ *Hora inicio:* ${acuerdoMutuo.horaInicio}
⌚ *Hora fin:* ${acuerdoMutuo.horaFin}
🏥 *Tipo Turno:* ${pacienteInfo.des_turno}
    
💵 *Valor del turno:* $${acuerdoMutuo.valorTurno}
🍽️ *Valor de colación:* $${acuerdoMutuo.valorColacion}
🚗 *Valor de movilización:* $${acuerdoMutuo.valorMovilizacion}
    
📝 *Observaciones:* ${acuerdoMutuo.observacion || "No hay observaciones"}

Por favor es obligatorio confirmar asistencia. 🙌

Si tienes alguna pregunta, ¡no dudes en contactarnos! 🙌`
    }

    return (
        <div className="container mt-4">
            <div className="card">
                <div className="card-body">
                    <h3 className="mb-4">Registrar Acuerdo Mutuo</h3>

                    {/* Filtros principales */}
                    <div className="row mb-3">
                        <div className="col-md-6">
                            <BuscarPaciente onSelect={handleSeleccionPaciente} valoresTurnos={true} conAcuerdos={true} conTurno={true} />
                        </div>
                        <div className="col-md-6">
                            <BuscarAuxiliar onSelect={handleSeleccionAuxiliar} />
                        </div>
                        <div className="col-md-12">
                            <label className="form-label">Paciente y Enfermera/o Seleccionado</label>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="p-3 border rounded">
                                        {pacienteInfo ? (
                                            <p>
                                                <strong>Paciente:</strong> {pacienteInfo.nombres} {pacienteInfo.apellidoPaterno}{" "}
                                                {pacienteInfo.apellidoMaterno}, RUT: {pacienteInfo.rut}
                                            </p>
                                        ) : (
                                            <p>No se ha seleccionado un paciente.</p>
                                        )}
                                        {auxiliarInfo ? (
                                            <p>
                                                <strong>Auxiliar:</strong> {auxiliarInfo.nombre} {auxiliarInfo.apellidoPaterno}{" "}
                                                {auxiliarInfo.apellidoMaterno}, RUT: {auxiliarInfo.rut}
                                            </p>
                                        ) : (
                                            <p>No se ha seleccionado un auxiliar.</p>
                                        )}
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="p-3 border rounded">
                                        {Array.isArray(datosAuxiliarAcuerdos) && datosAuxiliarAcuerdos.length > 0 ? (
                                            datosAuxiliarAcuerdos.map((acuerdo, index) => (
                                                <p key={index}>
                                                    <strong>Acuerdo ({acuerdo.tiene_acuerdo ? 'Activo' : 'Inactivo'}) con:</strong> {acuerdo.nombre} {acuerdo.apellidoPaterno}{" "}
                                                    {acuerdo.apellidoMaterno}, RUT: {acuerdo.rut}
                                                </p>
                                            ))
                                        ) : (
                                            <p>Paciente sin acuerdos.</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Inputs adicionales */}
                    <div className="row mb-3">
                        <div className="col-md-4">
                            <label className="form-label">Número de Celular</label>
                            <input
                                type="text"
                                className="form-control"
                                name="celular"
                                value={acuerdoMutuo.celular}
                                onChange={handleChange}
                                required={true}
                            />
                            <small className="w-100">Ejemplo: 912345678</small>
                        </div>
                        <div className="col-md-4">
                            <label className="form-label">Fecha inicio del acuerdo (Inicio Rotación)</label>
                            <input
                                type="date"
                                className="form-control"
                                name="fechaInicio"
                                value={acuerdoMutuo.fechaInicio}
                                onChange={handleFechaInicioChange} // Cambiamos el manejador
                                required={true}
                                readOnly={true}
                            />
                            <small className="text-danger mt-1 d-block">
                                * Fecha inicio del acuerdo es la fecha de inicio de la rotación, que se modifica en actualizar rotación.
                            </small>
                        </div>
                        {/* <div className="col-md-4 mb-3">
                            <label className="form-label">Tipo Turno</label>
                            <Select
                                options={turnos}
                                value={(() => {
                                    const selectedValue = turnos.find((option) => option.value === acuerdoMutuo.tipoTurno) || null
                                    return selectedValue
                                })()}
                                onChange={handleTurnoChange}
                                placeholder="Seleccione un turno"
                                isClearable
                            />
                        </div>
                        <div className="col-md-4">
                            <label className="form-label">Hora Inicio</label>
                            <input
                                type="time"
                                className="form-control"
                                name="horaInicio"
                                value={acuerdoMutuo.horaInicio}
                                onChange={handleChange}
                                required={true}
                            />
                        </div>
                        <div className="col-md-4">
                            <label className="form-label">Hora Fin</label>
                            <input
                                type="time"
                                className="form-control"
                                name="horaFin"
                                value={acuerdoMutuo.horaFin}
                                onChange={handleChange}
                                required={true}
                            />
                        </div> */}

                        {pacienteInfo?.patronTurno != null && (
                            <div className="row mb-4">
                                <div className="col-12">
                                    <h5>Fecha Inicio Servicio Paciente: {formatDate(pacienteInfo?.inicioRealServicio)}</h5>
                                    <h5>Selecciona un slot del patrón</h5>
                                    <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 8 }}>
                                        {slots.map((slot, i) => {
                                            slot.index = i;
                                            const esLibre = !slot.status || slot.status === "libre";
                                            const isSelected = acuerdoMutuo?.patternIndexes?.includes(slot.index);
                                            if (esLibre) {
                                                slot.status = "libre";
                                            }

                                            const label = getSlotLabelHumano(i, slots, pacienteInfo?.inicioRealServicio || '');


                                            const estadoTexto = isSelected
                                                ? "En este acuerdo"
                                                : esLibre
                                                    ? "Libre"
                                                    : "Ocupado";

                                            const fondo = isSelected
                                                ? "#ccf0ff"
                                                : esLibre
                                                    ? "#e6ffe6"
                                                    : "#ffe6e6";

                                            return (
                                                <div
                                                    key={slot.index}
                                                    onClick={() => {
                                                        if (esLibre) handleSlotSelect(slot, i);
                                                    }}
                                                    style={{
                                                        padding: 8,
                                                        borderRadius: 4,
                                                        cursor: esLibre ? "pointer" : "not-allowed",
                                                        backgroundColor: fondo,
                                                        textAlign: "center", fontSize: 12
                                                    }}
                                                >
                                                    <div>{label}</div>
                                                    <small>{slot.start}–{slot.end}</small>
                                                    <div style={{ opacity: 0.7 }}>
                                                        {estadoTexto}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        )}




                        {/* Días del turno - Ahora aparecen después de la selección */}
                        <div className="col-md-12 mt-3">
                            <div className="card">
                                <div className="card-body">
                                    <h5 className="card-title">Días del turno (referencial)</h5>
                                    <div className="row">
                                        {daysOfWeek.map((day) => (
                                            <div key={day.value} className="text-center" style={{ width: "14.28%", float: "left" }}>
                                                <label className="form-label d-block" htmlFor={day.value}>
                                                    {day.label}
                                                </label>
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id={day.value}
                                                    checked={datosDias.includes(day.value)}
                                                    disabled={true}
                                                    readOnly
                                                />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Valores del acuerdo */}
                    <div className="row mb-3">
                        <div className="col-md-4">
                            <label className="form-label">Valor del Turno</label>
                            <input
                                type="number"
                                className="form-control"
                                name="valorTurno"
                                value={acuerdoMutuo.valorTurno}
                                onChange={handleChange}
                                required={true}
                            />
                        </div>
                        <div className="col-md-4">
                            <label className="form-label">Valor de Colación</label>
                            <input
                                type="number"
                                className="form-control"
                                name="valorColacion"
                                value={acuerdoMutuo.valorColacion}
                                onChange={handleChange}
                                required={true}
                            />
                        </div>
                        <div className="col-md-4">
                            <label className="form-label">Tipo de Colación</label>
                            <select
                                className="form-select"
                                name="tipo_colacion"
                                value={acuerdoMutuo.tipo_colacion}
                                onChange={handleChange}
                            >
                                <option value="1">Día</option>
                                <option value="2">Noche</option>
                                <option value="3">Ambos</option>
                            </select>
                        </div>
                        <div className="col-md-4">
                            <label className="form-label">Valor de Movilización</label>
                            <input
                                type="number"
                                className="form-control"
                                name="valorMovilizacion"
                                value={acuerdoMutuo.valorMovilizacion}
                                onChange={handleChange}
                                required={true}
                            />
                        </div>
                    </div>

                    {/* Observaciones */}
                    <div className="row mb-4">
                        <div className="col-md-12">
                            <label className="form-label">Observación Acuerdo</label>
                            <textarea
                                className="form-control"
                                name="observacion"
                                rows="3"
                                value={acuerdoMutuo.observacion}
                                onChange={handleChange}
                            ></textarea>
                        </div>
                    </div>

                    {/* Botones */}
                    <div className="d-flex justify-content-end gap-3">
                        <button className="btn btn-primary" onClick={handleSubmit}>
                            Registrar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AcuerdoMutuo

